export default __webpack_public_path__ + "static/service-mesh-patterns-af811692423f972c4b4e69615a4be73b.webp";